import { createFileRoute } from "@tanstack/react-router";
import { HijriYearPage } from "@/components/pages/HijriYearPage";
import { currentHijriYear, HIJRI_MONTHS_EN } from "@/lib/calendar/hijri";
import { withSlash } from "@/lib/url";

/**
 * /en/hijri-calendar/ renders the current Hijri year hub directly
 * (200 OK, not a redirect) so the URL in sitemap/internal links is
 * not a 307. Canonical points to the dated /en/hijri-calendar/{year}/.
 */
export const Route = createFileRoute("/en/hijri-calendar/")({
  loader: () => ({ hYear: currentHijriYear() }),
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const y = loaderData.hYear;
    const title = `Hijri Calendar ${y} AH - Islamic Calendar Indonesia`;
    const desc = `Islamic (Hijri) calendar with Gregorian dates. Months: ${HIJRI_MONTHS_EN.join(", ")}.`;
    const canonical = `https://hari.co.id${withSlash(`/en/hijri-calendar/${y}`)}`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: () => {
    const { hYear } = Route.useLoaderData();
    return <HijriYearPage hYear={hYear} locale="en" />;
  },
});